import { homesApi as defaultHomesApi } from "@b2bportal/homes-api";
import axios from "axios";

export const homesApi = defaultHomesApi(axios);
